<!--  -->
<template>
    <cc-container class="purchase-history">
    <cc-header-nav title="收货地址">
      <template slot="left">
        <cc-svg-icon
          @click="$router.replace($route.query.path)"
          icon-class="left-arrow"
          class-name="left-arrow"
          size=".2rem"
        ></cc-svg-icon>
      </template>
      <template slot="right">
        <div  class="ellipsis">
          <van-icon class="ellipsis-icon" name="ellipsis" @click.stop="isShowSmallNav = !isShowSmallNav" />
        </div>
      </template>
    </cc-header-nav>
    <cc-main>
        <van-radio-group v-model="selectId"  @change="changeSelect">
            <ul class="address-list">
            <li class="address-list-item" v-for="item in addressData" :key="item.id">
              <div class="address-list-item-info"  @click="setAddress(item)">
                <p class="name">{{item.title}}</p>
                <p class="link"><b>{{item.contacter}}</b>  {{item.mobile}}</p>
                <p class="address">{{`${item.province}${item.city}${item.area}${item.address}`}}</p>
              </div>
              <div class="operation">
                  <van-radio
                    :checked-color="theme['APP_theme_color']"
                    :name="item.id">
                    默认地址
                  </van-radio>
                <div class="btns">
                  <div v-if="!address_setting_control" class="btn" @click="$router.push(`/receiver-address/add?id=${item.id}`)"><cc-svg-icon icon-class="edit"/>编辑</div>
                  <div v-if="!address_setting_control" class="btn" @click="handlerDel(item)"><cc-svg-icon icon-class="delete"/>删除</div>
                </div>
              </div>
            </li>
          </ul>
        </van-radio-group>
    </cc-main>
    <cc-small-nav v-model="isShowSmallNav"/>
    <cc-footer class="cc-footer">
      <div class="add-address" v-if="!address_setting_control" @click="$router.push('/receiver-address/add')">+新增地址</div>
    </cc-footer>
    </cc-container>
</template>

<script>
import Vue from 'vue'
import { getTheme } from '@/assets/styles/theme.js'
import { loadAddress, updateDefalut, delAddress } from '@/fetch/manage-center/receiver-address'
import { Icon, Toast, Dialog, RadioGroup, Radio } from 'vant'
import { ResultCode } from '~const/ResultCode'
import { mapGetters, mapActions } from 'vuex'
Vue.use(Icon)
  .use(Toast)
  .use(Dialog)
  .use(RadioGroup)
  .use(Radio)
export default {
  components: {},

  props: {},

  data () {
    return {
      selected: true,
      isShowSmallNav: false,
      address_setting_control: false,
      addressData: [],
      selectId: 0,
      isFirst: true
    }
  },
  computed: {
    ...mapGetters(['getReceiverAddress']),
    theme () {
      return getTheme()
    },
    selectedAddress () {
      return (value) => {
        return value === 1
      }
    }
  },

  watch: {},
  mounted () {},

  created () {
    this.loadData()
  },
  methods: {
    ...mapActions(['RECEIVER_ADDRESS']),
    setAddress (val) {
      if (this.$route.query.path === '/management') {
        return
      }
      this.RECEIVER_ADDRESS({
        id: val.id,
        title: val.title,
        contacter: val.contacter,
        mobile: val.mobile,
        address: `${val.province}${val.city}${val.area}${val.address}`
      })
      this.$router.push(this.$route.query.path)
    },
    async loadData () {
      let { status, data } = await loadAddress()
      if (status === ResultCode.SUCCESS) {
        this.addressData = data.address_info
        this.address_setting_control = data.address_setting_control
        this.addressData.forEach(item => {
          if (+item.is_default === 1) {
            this.selectId = item.id
          }
          this.$set(item, 'is_default', +item.is_default === 1)
        })
        let hasDefault = this.addressData.some(item => {
          return +item.is_default === 1
        })
        if (!hasDefault) {
          this.isFirst = false
        }
        if (this.getReceiverAddress && this.addressData.every(item => item.id !== this.getReceiverAddress.id)) { // 如果购物车选中的地址被删除就是用默认地址
          this.addressData.forEach(item => {
            if (+item.is_default === 1) {
              this.RECEIVER_ADDRESS({
                id: item.id,
                title: item.title,
                contacter: item.contacter,
                mobile: item.mobile,
                address: `${item.province}${item.city}${item.area}${item.address}`
              })
            }
          })
        }
      }
    },
    changeSelect (val) {
      if (!this.isFirst) {
        this.setDefaultAddress(val)
      } else {
        this.isFirst = false
      }
    },
    async setDefaultAddress (id) {
      let { status } = await updateDefalut({ address_id: id })
      if (status === ResultCode.SUCCESS) {
        this.selectId = id
        Toast('操作成功')
      } else {
        Toast('操作失败')
      }
    },
    handlerDel (item) {
      if (this.addressData.length === 1) {
        Toast('很抱歉，至少保留一个地址')
        return false
      }
      Dialog.confirm({
        message: '您确定要删除该地址吗？',
        title: ' ',
        className: 'dialog',
        beforeClose: async (action, done) => {
          if (action === 'confirm') {
            let { status } = await delAddress({
              address_id: item.id
            })
            if (status === ResultCode.SUCCESS) {
              this.handlerSuccess()
            } else {
              Toast('操作失败')
            }
            done()
          } else {
            done()
          }
        }
      })
    },
    handlerSuccess () {
      Toast({
        message: '操作成功',
        duration: 1000
      })
      this.loadData()
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  }
}

</script>
<style lang='scss' scoped>
.cc-footer{
  @include center();
  background: none!important;
  height: 70px!important;
  .add-address{
    width: 315px;
    height: 35px;
    border-radius: 17px;
    background: var(--APP_theme_color);
    color:#FFFFFF;
    font-size: 15px;
    @include center()
  }
}
.address-list{
  &-item{
    width: 355px;
    height: 130px;
    box-sizing: border-box;
    border-radius: 10px;
    background:rgba(255,255,255,1);
    margin: 10px;
    /*padding: 14px 15px 5px;*/
    color: #333333;
    font-size: 12px;
    &-info{
        min-height: 89px;
        box-sizing: border-box;
        padding: 13.5px 15px 15px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .name{
      color: #333333;
      font-size: 14px;
      @include ell();
    }
    .operation{
      height: 40px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid  #f6f5f5;
      color: #777777;
      .btns{
        display: flex;
        .btn{
          display: flex;
          align-items: center;
          margin-left: 15px;
        }
      }
    }
  }
}
.ellipsis{
  width: 100%;
  height: 100%;
  @include center();
  &-icon{
    transform: rotate(90deg);
  }
}
</style>
